import { colors } from "../../js/generateSchedule";
import AssignmentEntry from "./AssignmentEntry";
function HomeworkModal({dates}) {
    return (
        <div class="modal fade" id="homework" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog">
    <div class="modal-content bg-dark">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Homework</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      <div class="d-flex">
                        <ul class="mx-auto justify-content-center">
                            {dates !== 0 ?  Object.entries(dates).length > 0 ? Object.entries(dates).sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime()).map(([date, assignments]) => (
                              <div className="mt-4">
                                <h5 className="text-center">{date}</h5>
                                {Object.entries(assignments).length > 0 ? Object.entries(assignments).map(([c, assignment], i) => (
                                    assignment.hw.length > 0 &&
             
              <li key={date+i}><div class="card mt-4" style={{width: "20rem", backgroundColor:colors[assignment.block]}}>
                        <div class="card-body">
                        <h5 class="card-title text-center">{c.split(" ").slice(0, -1).join(" ")}</h5>
                        

                          {assignment.hw.map((a) => (
                            typeof a === "string" ? <p class="card-text pb-0 mb-0">{a}</p> :
                            <AssignmentEntry assignment={{entry:a.entry, desc:a.desc, date:date, className:c.split(" ").slice(0, -1).join(" ")}}/>
                          ))}
                    

                    </div>
          </div></li>)) : <li>
          <div class="card mt-4" style={{width: "20rem", backgroundColor:colors["MAIN"]}}>
                        <div class="card-body">
                        <p class="card-text text-center">No Homework!</p>

                        
                    

                    </div>
            </div>
          </li>}</div>)) : <li>
          <div class="card mt-4" style={{width: "20rem", backgroundColor:colors["MAIN"]}}>
                        <div class="card-body">
                        <p class="card-text text-center">No Homework!</p>

                        
                    

                    </div>
            </div>
          </li> : <p>Loading</p>}
                        </ul>
                    </div>
                </div>
                </div>
        

    </div>
    </div>
    )
}

export default HomeworkModal;